;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { AppCenteredStatus } from '@workspace/ui/components/custom/app-centered-status';
import { Button } from '@workspace/ui/components/button';
import { HELP_DESK_URL } from '@workspace/ui/components/layout/app-top-header-help-desk';
import { Lock } from 'lucide-react';

interface GeneralForbiddenPageProps {
  onGoHome: () => void;
  fillViewport?: boolean;
}

export function GeneralForbiddenPage({
  onGoHome,
  fillViewport = false,
}: GeneralForbiddenPageProps) {
  return (
    <AppCenteredStatus
      fillViewport={fillViewport}
      icon={
        <Lock
          aria-hidden="true"
          className="size-[74px] stroke-2! text-blue-500 dark:text-blue-500"
        />
      }
      title="You don't have access to this record"
      description="You don't have permission to view this record. If you think this is a mistake, contact your team lead or our support team."
      actions={
        <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center">
          <Button
            asChild
            variant="secondary"
            className="h-10 w-full min-w-0 shrink text-sm sm:flex-1"
          >
            <a href={HELP_DESK_URL} target="_blank" rel="noopener noreferrer">
              <p>Contact support</p>
            </a>
          </Button>
          <Button
            type="button"
            className="h-10 w-full min-w-0 shrink text-sm sm:flex-1"
            variant="primary"
            onClick={onGoHome}
          >
            <p>Go to homepage</p>
          </Button>
        </div>
      }
    />
  );
}
